import { Flag, Gem, Gift, Shield, Sparkles, Ticket } from "lucide-react";

interface PlayerStatusBarProps {
  identity: string;
  status: string;
  gems: number;
  vouchers: number;
  gloryValue: number;
  weeklyPassPoints?: number;
  inviteUnlocked?: boolean;
}

export function PlayerStatusBar({ identity, status, gems, vouchers, gloryValue, weeklyPassPoints = 0, inviteUnlocked = false }: PlayerStatusBarProps) {
  const items = [
    { label: "身份", value: identity || status || "聚耀成員", icon: <Shield size={16} /> },
    { label: "寶石碎片", value: gems, icon: <Gem size={16} /> },
    { label: "紅包券", value: vouchers, icon: <Gift size={16} /> },
    { label: "閃耀值", value: gloryValue, icon: <Sparkles size={16} /> },
    { label: "週通行證", value: `${weeklyPassPoints}/5`, icon: <Ticket size={16} /> },
    { label: "邀友支線", value: inviteUnlocked ? "已開啟" : "未開啟", icon: <Flag size={16} /> }
  ];

  return (
    <section className="player-status-bar" aria-label="玩家狀態">
      {items.map((item) => (
        <div className="player-token" key={item.label}>
          <span>{item.icon}</span>
          <small>{item.label}</small>
          <strong>{item.value}</strong>
        </div>
      ))}
    </section>
  );
}
